import React, { Component } from "react";
import { View, ScrollView, Image, SafeAreaView, TouchableOpacity } from 'react-native';
import { connect } from "react-redux";

// import Header from "../components/Header";
import Header from "../../../components/Header";
import { RadioButton } from "../../../components";
import { getServerResponse, phoneNumberFormate } from "../../../functions";
import styles from "../../../styles";
import { updateAuthState } from "../../../action";
import { global } from "../../../const";

import success_ic from '../../../assets/icon/check_ic.png';
import Stepper from "../../../components/util/Stepper";
import { PrimaryTitle } from "../../../components/labels";
import { TextInput, Button } from "../../../components/form";
import localize from "../../../localize";


class AccountSecurity extends Component {

    constructor(props) {
        super(props);
        this.state = {
            progress: 2,
            selection: 'phone',         // email OR phone
            phone: "",
            email: '',
            status: true,
            errorMessage: null,
            errorMessagePhone: localize.Invalid_letters_detected_in_phone_number,
        }
    }

    componentDidMount() {
        // if (!this.props.registerUser)
        //     return this._navigate(global.isNative ? "CreateAccount" : "Create-Account")
        // if (this.props.invitedUser && this.props.invitedUser !== 404) {
        //     if (this.props.invitedUser.mail_address)
        //         this.setState({ email: this.props.invitedUser.mail_address, selection: 'email', status: false })
        // }
    }

    _navigate = (pathname, state, search) => {
        if (!global.isNative) {
            return this.props.history.push({
                pathname: '/' + pathname,
                state,
                search
            });
        }
        return this.props.navigation.navigate(pathname, state)
    };

    onEmailChange = (state) => async (email) => {
        let status = false,
            errorMessage = null;
        this.setState({ [state]: email });
        try {
            const response = await getServerResponse({ cmd: "WcnUser1.checkEmail", email });
            if (response) {
                if (response === 1) {
                    status = true;
                    errorMessage = localize.Invalid_format_of_email_address;
                }
            }
            return this.setState({ errorMessage, status });
        } catch (error) {

        }
    }

    onPhoneChange = async (phone) => {
        let errorMessagePhone = this.state.errorMessagePhone;
        phone = phone.replace(/-/g, '');
        this.setState({ phone });
        try {
            phone = phone.replace(/-/g, '');
            const response = await getServerResponse({ cmd: "WcnUser1.checkPhone", phone });
            if (response === 200) errorMessagePhone = null
            else errorMessagePhone = localize.Invalid_letters_detected_in_phone_number
        } catch (error) {

        }
        return this.setState({ errorMessagePhone });
    }

    handleOption = value => this.setState({ selection: value })

    _submit = () => {
        let { phone, email, selection } = this.state;
        phone = phone.replace(/-/g, '');
        phone = selection === 'phone' ? phone : ''
        email = selection === 'email' ? email : ''

        let registerUser = this.props.registerUser;
        registerUser = Object.assign({}, registerUser, { security_phone: phone, security_email: email })
        this.props.updateAuthState({ registerUser })
        this._navigate('confirm_details')
    }

    render() {
        const { phone, selection, email, errorMessage, errorMessagePhone } = this.state;

        return (
            <SafeAreaView style={styles.container}>
                <Header title={localize.Account_Security} goBack={() => this.props.history.goBack()} />
                <ScrollView
                    keyboardShouldPersistTaps="handled"
                    style={{ padding: 15 }}
                >
                    <Stepper value={2} step={4} />
                    <PrimaryTitle>
                    {localize.How_would_you_like_us_to_communicate_with_you_about_security}
                    </PrimaryTitle>
                    <View>
                        <View style={{ flexDirection: 'row', alignItems: 'center', paddingVertical: 15, paddingTop: 30 }}>
                            <RadioButton
                                selected={selection === 'phone'}
                                onPress={() => this.handleOption('phone')}
                            />
                            <TouchableOpacity
                                style={{ paddingLeft: 10 }}
                                onPress={() => this.handleOption('phone')}
                                activeOpacity={0.7}>
                                <PrimaryTitle>
                                {localize.phone_number}
                                </PrimaryTitle>
                            </TouchableOpacity>
                        </View>
                        <View style={{ flexDirection: 'row', alignItems: 'center' }}>
                            <RadioButton
                                selected={selection === 'email'}
                                onPress={() => this.handleOption('email')}
                            />
                            <TouchableOpacity
                                style={{ paddingLeft: 10 }}
                                onPress={() => this.handleOption('email')}
                                activeOpacity={0.7}>
                                <PrimaryTitle>
                                {localize.email_address}
                                </PrimaryTitle>
                            </TouchableOpacity>
                        </View>

                        <View style={{ paddingTop: 30 }}>
                            {
                                selection === "phone" && (
                                    <TextInput
                                        title={localize.MOBILE_PHONE}
                                        placeholder="X-XXX-XXX-XXXX"
                                        keyboardType='phone-pad'
                                        value={phoneNumberFormate(phone)}
                                        onChangeText={this.onPhoneChange}
                                        error={phone !== '' ? errorMessagePhone : null}
                                        right={
                                            phone === '' ? null : errorMessagePhone === null ?
                                                <Image source={success_ic} resizeMode="contain" style={{ height: 18, width: 18 }} />
                                                : null
                                        }
                                    />
                                )
                            }
                            {
                                selection === "email" && (
                                    <TextInput
                                        title={localize.EMAIL_ADDRESS}
                                        placeholder={localize.EMAIL_ADDRESS}
                                        keyboardType="email-address"
                                        value={email}
                                        onChangeText={this.onEmailChange("email")}
                                        error={errorMessage}
                                    />
                                )
                            }
                        </View>
                        <View style={{ paddingVertical: 30 }} >
                            <Button
                                title={localize.SAVE}
                                disabled={this.handleButtonVisible()}
                                onPress={this._submit}
                            />
                        </View>
                    </View>
                </ScrollView>
            </SafeAreaView>
        );
    }

    handleButtonVisible = () => {
        const { selection, phone, status, errorMessagePhone } = this.state;
        if (selection === 'phone') {
            if (phone === '') return true;
            if (errorMessagePhone !== null) return true;
            return false;
        }
        return status;
    }

}

const mapStateToProps = ({ setting, auth }) => {
    return {
        height: setting.height,
        registerUser: auth.registerUser,
        invitedUser: auth.invitedUser
    };
};
const mapDispatch = (dispatch) => {
    return {
        updateAuthState: request => dispatch(updateAuthState(request)),
    }
}

export default connect(mapStateToProps, mapDispatch)(AccountSecurity);

